import React from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';

import ReactResizeDetector from 'react-resize-detector';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

Highcharts.setOptions({
  global: {
    useUTC: false,
  },
});

class CustomLineChart extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
    };
  }

  render() {
    const { options } = this.props;

    const chartObject = {
      chart: {
        type: options?.type ?? 'line',
        width: this.state.width === 0 ? options?.width : this.state.width,
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              legend: {
                enabled: false,
              },
            },
          },
        ],
      },
      rangeSelector: {
        buttons: [
          {
            type: 'day',
            count: 1,
            text: '1d',
          },
          {
            type: 'week',
            count: 1,
            text: '1w',
          },
          {
            type: 'month',
            count: 1,
            text: '1m',
          },
          {
            type: 'all',
            text: '6m',
            events: {
              click: () => options.evnt(),
            },
          },
        ],
        inputEnabled: true,
        selected: options.selected ?? 0,
        inputBoxWidth: 75,
        inputBoxHeight: 18,
        buttonTheme: {
          height: 18,
          padding: 2,
          undefined: 0,
          width: 15,
          Index: 7,
        },
      },
      title: {
        text: options.title ?? '',
      },
      xAxis: options.xAxis ?? {
        type: 'datetime',
      },
      yAxis: options.yAxis ?? {
        title: {
          text: options.unit ?? '',
        },
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              'downloadPNG',
              'downloadJPEG',
              'downloadPDF',
              'downloadSVG',
              'separator',
              'downloadCSV',
              'downloadXLS',
              'viewData',
            ],
          },
        },
      },
      navigator: {
        enabled: false,
        reversed: false,
      },
      tooltip: {
        pointFormat:
          '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
        valueDecimals: 2,
        split: true,
      },
      credits: {
        enabled: false,
      },
      series: options.series ?? [],
    };
    return (
      <div>
        <HighchartsReact
          highcharts={Highcharts}
          constructorType={'stockChart'}
          options={chartObject}
        />
        <ReactResizeDetector
          handleWidth
          onResize={(width) => this.setState({ width: Math.floor(width) })}
        />
      </div>
    );
  }
}
export default CustomLineChart;
